import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
// import Paper from '@mui/material/Paper';
// import Draggable from 'react-draggable';
import ButtonAction from '../Button.js/SaveButton';
import { useTranslation } from 'react-i18next';
// function PaperComponent({ ...props }) {
//     return (
//         <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
//             <Paper {...props} />
//         </Draggable>
//     );
// }

export default function ConfirmLockModal({ visible = false, setVisible, handleSave, loader, title, mesages }) {
    const { t } = useTranslation();

    return (
        <div>
            <Dialog open={visible} onClose={() => setVisible(false)} aria-labelledby="draggable-dialog-title">
                <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                    {t('notify')}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('message_confirm')}?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <ButtonAction
                        title={t('cancel')}
                        onClick={() => setVisible(false)}
                        // variant="text"
                        type="cancel"
                    />
                    <ButtonAction title={t('save')} type="save" onClick={handleSave} />
                </DialogActions>
            </Dialog>
        </div>
    );
}
